//En este componente se muestran para su edición los valores de diversos datos relativos al cierre diario (afluencia, niños en fiestas de cumpleaños, incidencias en pistas ....)
//  utilizando los componentes de /cierre_diario_otros_datos_componentes para mantener el aspecto de la pantalla existente en el antiguo TCW
//En este componente no se permite cambiar el centro ni el dia de cierre y se obtienen los datos con una llamada a la acción getOtrosDatosCierreDiario
//El botón de guardar llama a la acción newOtrosDatosDB o updateOtrosDatosDB para actualizar los datos en el servidor y después hace un nextStep del Stepper de AccCierreDiario 
//    para que se muestre el componente CierreDiarioResumen.

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

//material ui components:
import CircularProgress from '@material-ui/core/CircularProgress';
import { Paper, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';

//actions:
import { getOtrosDatosCierreDiario, newOtrosDatosDB, updateOtrosDatosDB } from '../../actions/cierre_diario_actions';
import {  setSaveState } from '../../actions';

//components:
import CumpleanosTable from './cierre_diario_otros_datos_components/cumpleaños_table';
import SatisfaccionTable from './cierre_diario_otros_datos_components/satisfaccion_table';
import Apertura from './cierre_diario_otros_datos_components/Apertura';
import Operativa from './cierre_diario_otros_datos_components/Operativa';
import Cierre from './cierre_diario_otros_datos_components/Cierre';
import FirstRowPapers from './cierre_diario_otros_datos_components/first_row_papers';
import SecondRowPapers from './cierre_diario_otros_datos_components/second_row_papers';
import ThirdRowPapers from './cierre_diario_otros_datos_components/third_row_papers';



//styles:
const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        margin: theme.spacing(1),
        flexGrow: 1,
        fontSize: 13,
        fontWeight: '600',
    },
    paperCaja: {
        backgroundColor: '#E8F1D7',
        boxShadow: 'none',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
        margin: '25px 0',
        padding: 10,
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    container: {
        padding: 0,
        fontSize: 13,
        fontWeight: '600',
        margin: '0 8px',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        height: '100%',
    },
    paperTitle: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        backgroundColor: 'black',
        padding: '4px 2px 4px 12px',
        margin: 0,
    },
    encuestasContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        height: 165,
    },
    rightsideContainer: {
        paddingBottom: '0px !important',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
}); 

class CierreDiarioOtrosDatos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showAll: false,
            showSpinner: true,
        };
    };


    componentDidMount() {
        this.props.getOtrosDatosCierreDiario(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
    };


    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreDiario !== this.props.otrosDatosCierreDiario) {
            this.setState({
                showAll: true,
            });
        };

        if (prevProps.isLoading !== this.props.isLoading && this.props.isLoading) this.setState({ showSpinner: true });
        if (prevProps.isLoading !== this.props.isLoading && !this.props.isLoading) this.setState({ showSpinner: false });
    };

    saveHandler = () =>{
        this.props.setSaveState(false);
        this.props.nextStep();
    }

    hanldeOKClick = () => {

        const otrosDatos = this.props.otrosDatosCierreDiario;
        const id = !this.props.otrosDatosCierreDiario.id ? 0 : this.props.otrosDatosCierreDiario.id;

        if (!this.props.isDiaCerrado) {

            if (id === 0) {
                //create new otrosdatos de cierre diario (post):
                this.props.newOtrosDatosDB(otrosDatos, this.saveHandler);
            } else {
                //modify existing otrosdatos (put):
                this.props.updateOtrosDatosDB(otrosDatos, id, this.saveHandler);
            };
        }
        else{
            this.props.nextStep();
        }

    };

    render() {
        const { classes } = this.props;

        if (this.state.showAll && !this.state.showSpinner) {
            return (
                <div className={classes.root}>

                    <Paper className={classes.paperCaja} elevation={0}>
                        <Grid container spacing={8}>

                            {/* main */}
                            <Grid item xs={8} className={classes.mainContainer}>
                                <FirstRowPapers />
                                <SecondRowPapers />
                                <ThirdRowPapers />

                                {/*fourth row:*/}
                                <div style={{ height: 195, width:550 }}>
                                    <Paper className={classes.container} elevation={0}>
                                        <p className={classes.paperTitle}>Encuestas</p>

                                        <div className={classes.encuestasContainer}>
                                            <CumpleanosTable />
                                        </div>
                                    </Paper>
                                </div>

                            </Grid> {/*end main*/}

                            {/* right side */}
                            <Grid item xs={4} className={classes.rightsideContainer}>
                                <Apertura />
                                <Operativa />
                                <Cierre />

                            </Grid>
                        </Grid>
                    </Paper>


                    <div>
                        <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={this.props.prevStep}>Atrás</Button>
                        <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={this.hanldeOKClick} >
                            {this.props.isDiaCerrado ? 'Siguiente' : 'Guardar'}
                        </Button>
                    </div>

                </div>
            );

        };

        return (
            <div className={classes.spinnerContainer}>
                <CircularProgress className={classes.spinner} color="primary" />
            </div>
        );
    };
};


CierreDiarioOtrosDatos.propTypes = {
    user: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    otrosDatosCierreDiario: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    getOtrosDatosCierreDiario: PropTypes.func.isRequired,
    newOtrosDatosDB: PropTypes.func.isRequired,
    updateOtrosDatosDB: PropTypes.func.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
    prevStep: PropTypes.func.isRequired,
};


function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected,
        otrosDatosCierreDiario: state.otrosDatosCierreDiario.datos,
        isLoading: state.otrosDatosCierreDiario.isLoading,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        getOtrosDatosCierreDiario,
        newOtrosDatosDB,
        updateOtrosDatosDB,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreDiarioOtrosDatos));
